import React from 'react';
import ReactLoader from 'react-loading';

/* spin types
  balls
  bars
  bubbles
  cubes
  cylon
  spin
  spinningBubbles
  spokes
*/

const Loader = ({ backgroundColor, color, loadWidth, loadHeight, width, height, text, type }) => (
    <div style={{ 
        backgroundColor: backgroundColor || 'transparent',
        height: height|| '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center'}}
    >
        <ReactLoader type={ type || 'spin' } color={ color || 'black' } 
            height={ loadHeight || 'fit-content' } width={ loadWidth || '10vw' }  
        />
        { text && <span style={{ color: color || 'black' , fontSize: '1.5em' }}>{ text }</span> }
    </div>
);

export default Loader;


// WEBPACK FOOTER //
// ./src/components/commons/loader/loader.js